import { Component, OnInit, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { QualityIP, SaveStatusObj, SSOStatus, SOModule, SaveEventType, SalesOrder, ValidationItem, ValidationSummary, ActualDateChange, PlannedDateToken, ActualDateToken, RequestDateToken, GenFileUploads } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DataService } from '../../../shared/dataservice.service';
import { ValidationDialog } from '../../../dialogs/validation-dialog/validation-dialog';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';

@Component({
  selector: 'quality',
  templateUrl: './quality.component.html',
  styleUrls: ['./quality.component.css']
})
export class QualityComponent implements OnInit, OnChanges {

  @Input() qualityObj: QualityIP;
  @Input() soLockObtained:boolean;
  @Input() loadCounter:SalesOrder;
  @Output() updateSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  @Output() showTestingFilesUploadManager: EventEmitter<GenFileUploads> = new EventEmitter();
  disableForm: boolean = true;
  public _SSOStatus = SSOStatus;
  Hvr:any={};
  modifyReqDate: boolean = false;
  modifyPlanDate:boolean = false;
  inputDisableMessage:string = '';
  enableRelayProgrammingUpload:boolean = false;
  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.modifyReqDate = this._dataService.modifyReqDate;
  }

  ngOnChanges() {
    this.disableForm = true;
    if(this.soLockObtained == false){
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    else if (!this.qualityObj.isProjectLive) {
      this.inputDisableMessage = "Project is on HOLD or TO BE CANCELLED";
    }
    else if (!this.qualityObj.isInputEnabled) {
      this.inputDisableMessage = "This form is not yet enabled.";
      if(this._dataService.hasTestingEditAccess == true){
        this.enableRelayProgrammingUpload = true;
        this.inputDisableMessage = "This form is not yet enabled, But Relay Programming File Upload can be uploaded.";
      }
    }
    else if (!this._dataService.hasTestingEditAccess) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
    }
    this.qualityObj.fileUploadForTesting.disableUpload = this.disableForm;
    this.qualityObj.finalRlyPrgFiles.disableUpload = this.disableForm;
  }

  saveSso(_submitToNextSection:boolean,ssoSubmitTo:SSOStatus = SSOStatus.Not_Started){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data),
          null,
          ssoSubmitTo
        ));
    }
  }

  showSsoValidation(){
    let _validList:Array<ValidationItem> = [
      new ValidationItem("Green Sticker Actual Date", (this.qualityObj.greenStickerActualDate ? true : false)," required to move to logistic." )
    ] ;

    let vSummaryObj:ValidationSummary = new ValidationSummary("Validation Summary.",_validList);
    
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }

  reloadData() {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Reload_Data));
    }

  }
  deleteSSo(_deleteSO:boolean){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Delete_SubSale_Order));
    }
  }

  requestDateChangeHandler(_reqDateHeader:string, _reqTokenKeyName:string,_plndReqDate:Date,_reqDateChanged:Date):void{
    let _plndDateChangeObj:ActualDateChange = new ActualDateChange("Why is the request date changed ?", _reqDateHeader + "(existing)", 
    _plndReqDate, _reqDateHeader + "(edited)", _reqDateChanged, this.qualityObj[_reqTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.qualityObj[_reqTokenKeyName].requestDate = _reqDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.qualityObj[_reqTokenKeyName] = 
          new RequestDateToken(new Date(_reqDateChanged.getTime()), true, null, _plndDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.qualityObj[_reqTokenKeyName].requestDate = _plndReqDate;
      }
    });
  }

  plannedDateChangeHandler(_plndDateHeader:string, _plndTokenKeyName:string,_plndDate:Date,_plndDateChanged:Date):void{
    let _plndDateChangeObj:ActualDateChange = new ActualDateChange("Why is the planned date changed ?", _plndDateHeader + "(existing)", 
                                                  _plndDate, _plndDateHeader + "(edited)", _plndDateChanged, this.qualityObj[_plndTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.qualityObj[_plndTokenKeyName].plannedDate = _plndDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.qualityObj[_plndTokenKeyName] = 
          new PlannedDateToken(new Date(_plndDateChanged.getTime()), true, null, _plndDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.qualityObj[_plndTokenKeyName].plannedDate = _plndDate;
      }
    });
  }

  actualDateChangeHandler(_actDateHeader:string,_actDate:Date,_actDateChanged:Date,_actTokenKeyName:string,_plndDateHeader:string,_plndDate:Date,):void{
    let _actDateChangeObj:ActualDateChange = new ActualDateChange("Additional Comment", _plndDateHeader, _plndDate, _actDateHeader, 
                                                              _actDateChanged, this.qualityObj[_actTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _actDateChangeObj
    });
    let _prevActualDate:Date = this.qualityObj[_actTokenKeyName].actualDate;
    this.qualityObj[_actTokenKeyName].actualDate = _actDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.qualityObj[_actTokenKeyName].actualDate = _actDateChangeObj.actualDate;
        var changedDate: Date = null;
        if(_actDateChangeObj.actualDate != null){
          changedDate = new Date(_actDateChangeObj.actualDate.getTime());
        }
        this.qualityObj[_actTokenKeyName] = 
          new ActualDateToken(changedDate, true, _plndDate, _actDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.qualityObj[_actTokenKeyName].actualDate = _prevActualDate;
      }
    });
  }
  testingFilesUploadClick(_evn:any, forceRlyFileUpload:boolean){
    _evn.stopPropagation();
    if(forceRlyFileUpload == true){
      this.qualityObj.fileUploadForTesting.disableUpload = false;
    }
    else{
      this.qualityObj.fileUploadForTesting.disableUpload = this.disableForm;
    }
    this.qualityObj.fileUploadForTesting.headerStr = "Relay Programming File Upload from DA"  + " - " + this.qualityObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.qualityObj.parentSubSORef.subOrderNoId;
    this.showTestingFilesUploadManager.emit(this.qualityObj.fileUploadForTesting);
  }

  finalRlyPrgFileUploadClick(_evn:any){
    _evn.stopPropagation();
    this.qualityObj.finalRlyPrgFiles.headerStr = "Final Relay Programming File"  + " - " + this.qualityObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.qualityObj.parentSubSORef.subOrderNoId;
    this.showTestingFilesUploadManager.emit(this.qualityObj.finalRlyPrgFiles);
  }
  
}
